const chartImageExporters = new WeakMap();

export function registerChartImageExporter(host, exporter) {
    if (!host || typeof exporter !== "function") return host;
    chartImageExporters.set(host, exporter);
    return host;
}

export function getChartImageExporter(host) {
    return host ? chartImageExporters.get(host) : undefined;
}
